// src/contexts/AuthContext.js
import React, {
	createContext,
	useContext,
	useEffect,
	useState,
	useRef,
} from "react";
import {
	info_auto_login,
	info_auto_refreshAccessToken,
} from "../api/endpoints/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
	const [isAuthenticated, setIsAuthenticated] = useState(false);
	const isLoggingIn = useRef(false);

	const login = async () => {
		if (isLoggingIn.current) return;
		isLoggingIn.current = true;

		const success = await info_auto_login();
		setIsAuthenticated(success);
		isLoggingIn.current = false;
	};

	const refreshToken = async () => {
		const newToken = await info_auto_refreshAccessToken();
		if (newToken) {
			setIsAuthenticated(true);
			return newToken;
		} else {
			await login();
			return localStorage.getItem("info_auto_access_token");
		}
	};

	const getAccessToken = async () => {
		let token = localStorage.getItem("info_auto_access_token");
		if (!token) {
			await login();
			token = localStorage.getItem("info_auto_access_token");
		}
		return token;
	};

	useEffect(() => {
		login();
	}, []);

	return (
		<AuthContext.Provider
			value={{
				isAuthenticated,
				getAccessToken,
				refreshToken,
				login,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
